import {MOUSE} from "three";

export enum ControlType {
  Encompass,
  Reverse,
  Autocad
}

export const ControlModes = {
  0: { ORBIT: MOUSE.LEFT, ZOOM: MOUSE.MIDDLE, PAN: MOUSE.RIGHT },
  1: { ORBIT: MOUSE.RIGHT, ZOOM: MOUSE.MIDDLE, PAN: MOUSE.LEFT },
  2: { ORBIT: -1, ZOOM: -1, PAN: MOUSE.MIDDLE }
};
